import { track } from "../../config/amplitude";

const FEATURE = "gst_recon";
const url = () => window.location.pathname;

// AppState → canonical page_name used in page_viewed events
export const GST_PAGE_NAMES: Record<string, string> = {
  landing:       "landing",
  manage_gstins: "connect_gst",
  upload_pr:     "upload",
  reconciling:   "processing",
  dashboard:     "dashboard",
};

export function trackGstPageViewed(pageName: string, referrerPageName?: string) {
  track("page_viewed", {
    feature: FEATURE,
    page_name: pageName,
    page_url: url(),
    ...(referrerPageName ? { referrer_page_name: referrerPageName } : {}),
  });
}

export function trackGstButtonClicked(ctaText: string, section: string) {
  track("button_clicked", {
    feature: FEATURE,
    cta_text: ctaText,
    section,
    page_url: url(),
  });
}

export function trackGstFilterApplied(
  filterType: "date_range" | "search" | "time_range" | "gstin_filter" | "sort" | "needs_action" | "internal_transfers",
  opts: {
    context?: string;
    period_label?: string;
    start_date?: string;
    end_date?: string;
    search_query?: string;
    result_count?: number;
    sort_key?: string;
    sort_direction?: string;
  } = {}
) {
  track("filter_applied", {
    feature: FEATURE,
    filter_type: filterType,
    page_url: url(),
    ...opts,
  });
}

export function trackGstRowSelected(
  context: "invoice_reconciliation" | "resolve_mismatches",
  entityId: string,
  rowPosition: number,
  opts: {
    match_status?: string;
    claim_status?: string;
    side?: "books" | "gstr";
  } = {}
) {
  track("row_selected", {
    feature: FEATURE,
    context,
    entity_type: "invoice",
    entity_id: entityId,
    row_position: rowPosition,
    page_url: url(),
    ...opts,
  });
}

export function trackGstStatusUpdated(
  entityId: string,
  previousStatus: string,
  newStatus: string,
  source: "table" | "drawer" | "bulk" | "mismatch_tab",
  opts: { entity_count?: number; invoice_value?: number } = {}
) {
  track("status_updated", {
    feature: FEATURE,
    entity_type: "invoice",
    entity_id: entityId,
    entity_count: opts.entity_count ?? 1,
    previous_status: previousStatus,
    new_status: newStatus,
    source,
    ...(opts.invoice_value != null ? { invoice_value: opts.invoice_value } : {}),
    page_url: url(),
  });
}

export function trackGstProgressUpdated(
  progressType: "gstin_connected" | "file_added" | "file_removed" | "invoice_note_added" | "processing_started" | "processing_completed" | "tally_connected" | "tally_synced" | "tally_sync_failed" | "tally_tdl_downloaded" | "tally_tdl_not_downloaded",
  opts: {
    gstin?: string;
    success?: boolean;
    error_code?: string;
    error_message?: string;
    context?: "new" | "reconnect";
    source_name?: string;
    file_count?: number;
    upload_method?: "drag_drop" | "browse";
    gstin_count?: number;
    entity_id?: string;
    duration_seconds?: number;
    invoice_count?: number;
    match_rate?: number;
    matched_count?: number;
    mismatch_count?: number;
  } = {}
) {
  track("progress_updated", {
    feature: FEATURE,
    progress_type: progressType,
    page_url: url(),
    ...opts,
  });
}

export function trackGstErrorShown(
  formName: string,
  errorCode: string,
  errorMessage: string,
  fieldName?: string
) {
  track("error_shown", {
    feature: FEATURE,
    form_name: formName,
    error_code: errorCode,
    error_message: errorMessage,
    ...(fieldName ? { field_name: fieldName } : {}),
    page_url: url(),
  });
}
